module.exports = __webpack_public_path__ + "img/background-fl-detail.72fe39e1.svg";